import React from "react";
import { useParams } from "react-router-dom";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import LocationData from "../../data/footer_location.json";
import BreadcrumbForFooterLocations from "../Breadcrumb/BreadcrumbForFooterLocations";
import SanAntonio from "../Location_contents/SanAntonio";
import LosAngeles from "../Location_contents/LosAngeles";
import NewYork from "../Location_contents/NewYork";

const FooterLocations = () => {
  const { city } = useParams();

  const pageData = LocationData[city] || {
    content: "<p>Content not found.</p>",
  };
  const { BreadcrumbImage, cityName } = pageData;

  return (
    <>
      <div style={{ backgroundColor: "#f5f5f5" }}>
        <HeaderOne imageData="/img/aaban-text-logo.png" />
        <BreadcrumbForFooterLocations image={BreadcrumbImage} />
        <div
          style={{
            background:
              "linear-gradient(to right, rgb(95, 218, 255), rgb(75, 231, 13))",
            textAlign: "center",
          }}
        >
          <h2 className="text-center pt-5 pb-5">
            Digital Marketing Agency in{" "}
            {city.replace("-", " ").replace(/\b\w/g, (c) => c.toUpperCase())}
          </h2>
        </div>
    
        <div className="container pt-5 pb-5">
          {
            cityName === "los-angeles" ? (
              <LosAngeles />
            ) : cityName === "san-antonio" ? (
              <SanAntonio />
            ) : cityName === "new-york" ? (
              <NewYork />
            ) : (
              <p>Content not found.</p>
            )
          }
        </div>
      </div>
      <FooterOne />
    </>
  );
};

export default FooterLocations;
